var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVault = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "folder",
    fillRule: "evenodd",
    d: "M3 10.316v3.235c0 .179.168.324.375.324h11.25c.207 0 .375-.145.375-.324V7.11c0-.18-.168-.324-.375-.324H9c-.225 0-.438-.102-.58-.276L6.47 4.125H3.374c-.207 0-.375.145-.375.323v5.868zm11.625 5.06H3.375c-1.034 0-1.875-.819-1.875-1.825V4.448c0-1.005.841-1.823 1.875-1.823h3.45c.225 0 .439.1.581.275l1.95 2.385h5.269c1.034 0 1.875.817 1.875 1.824v6.442c0 1.006-.841 1.824-1.875 1.824z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVault, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vault.6c019b4e.svg";
export { ForwardRef as ReactComponent };